'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_InvoiceLineItem(name, unitPrice, quantity, quantityUnit, vatRate, grossWeight, netWeight, discount, referenceNumber) {
  this.aBT = null;
  this.BE = null;
  this.z1 = null;
  this.LH = null;
  this.LI = null;
  this.uN = null;
  this.qH = null;
  this.qI = null;
  this.yZ = null;
  this.z0 = null;
  this.BE = name;
  this.z1 = unitPrice;
  this.LH = quantity;
  this.LI = quantityUnit;
  this.uN = vatRate;
  this.qH = grossWeight;
  this.qI = netWeight;
  this.yZ = discount;
  this.z0 = referenceNumber;
  var this$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Extract$();
  this.aBT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Extract$$anon$1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_package$().FX, this$2);
  var this$4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Extract$();
  new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Extract$$anon$1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_package$().FX, this$4);
}
export { $c_Lapp_data_InvoiceLineItem as $c_Lapp_data_InvoiceLineItem };
$p = $c_Lapp_data_InvoiceLineItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_InvoiceLineItem;
/** @constructor */
function $h_Lapp_data_InvoiceLineItem() {
}
export { $h_Lapp_data_InvoiceLineItem as $h_Lapp_data_InvoiceLineItem };
$h_Lapp_data_InvoiceLineItem.prototype = $p;
$p.IB = (function() {
  return this.aBT;
});
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_InvoiceLineItem)) {
    if ((this.BE === x$0.BE)) {
      var x = this.z1;
      var x$2 = x$0.z1;
      var $x_6 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.LH;
      var x$4 = x$0.LH;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_5 = false;
    }
    if (($x_5 && (this.LI === x$0.LI))) {
      var x$5 = this.uN;
      var x$6 = x$0.uN;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.qH;
      var x$8 = x$0.qH;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.qI;
      var x$10 = x$0.qI;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.yZ;
      var x$12 = x$0.yZ;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.z0;
      var x$14 = x$0.z0;
      return ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 9;
});
$p.t = (function() {
  return "InvoiceLineItem";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.BE;
      break;
    }
    case 1: {
      return this.z1;
      break;
    }
    case 2: {
      return this.LH;
      break;
    }
    case 3: {
      return this.LI;
      break;
    }
    case 4: {
      return this.uN;
      break;
    }
    case 5: {
      return this.qH;
      break;
    }
    case 6: {
      return this.qI;
      break;
    }
    case 7: {
      return this.yZ;
      break;
    }
    case 8: {
      return this.z0;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "unitPrice";
      break;
    }
    case 2: {
      return "quantity";
      break;
    }
    case 3: {
      return "quantityUnit";
      break;
    }
    case 4: {
      return "vatRate";
      break;
    }
    case 5: {
      return "grossWeight";
      break;
    }
    case 6: {
      return "netWeight";
      break;
    }
    case 7: {
      return "discount";
      break;
    }
    case 8: {
      return "referenceNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Kb = (function() {
  return this.z1;
});
$p.Es = (function() {
  return this.LH;
});
$p.agr = (function() {
  return this.LI;
});
$p.bxa = (function() {
  return this.uN;
});
$p.aey = (function() {
  return this.yZ;
});
$p.a5q = (function() {
  return this.qH;
});
$p.a5O = (function() {
  return this.qI;
});
function $isArrayOf_Lapp_data_InvoiceLineItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jE)));
}
export { $isArrayOf_Lapp_data_InvoiceLineItem as $isArrayOf_Lapp_data_InvoiceLineItem };
var $d_Lapp_data_InvoiceLineItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_InvoiceLineItem, "app.data.InvoiceLineItem", ({
  jE: 1,
  eC: 1,
  jA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_InvoiceLineItem as $d_Lapp_data_InvoiceLineItem };
//# sourceMappingURL=app.data.-Invoice-Line-Item.js.map
